import { useEffect } from 'react';
import { Stack } from '@mui/material';
import { SubscribeCard } from './SubscribeCard';

interface SubscribeInPlaceProps {
  /**
   * Names the card's title. With `focusTitle`, focus moves to it as the card replaces the modal's
   * content (the host's previous control has just unmounted).
   */
  titleId?: string;
  focusTitle?: boolean;
  /**
   * The host modal's close. The CTA closes the host before the subscribe dialog opens, so two
   * dialogs never stack (DLG-005, TMMAPP-0117 B6). Every modal host passes it; a card on a page
   * has nothing to close.
   */
  onClose?: (() => void) | undefined;
}

/**
 * The subscribe card in place of a modal's content (DLG-005, TMMAPP-0097 §C 25). A dialog or drawer
 * whose write answers `SUBSCRIPTION_REQUIRED` swaps its body for this card: a second dialog never
 * opens on top. The host keeps its own Close / Cancel, and the purchase itself is the card's CTA
 * (the subscribe dialog, TMMAPP-0116), which closes the host first, as `AllocateDialog`'s
 * create-a-virtual-account prompt does.
 */
export function SubscribeInPlace({ titleId, focusTitle = false, onClose }: SubscribeInPlaceProps) {
  useEffect(() => {
    if (focusTitle && titleId !== undefined) document.getElementById(titleId)?.focus();
  }, [focusTitle, titleId]);
  return (
    <Stack sx={{ my: 1, alignItems: 'flex-start' }}>
      <SubscribeCard
        {...(titleId !== undefined ? { titleId } : {})}
        {...(onClose !== undefined ? { onNavigate: onClose } : {})}
      />
    </Stack>
  );
}
